export default "__VITE_ASSET__0xKI4fb2__"